(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!window.ManilaEditorialMotion) {
    window.ManilaEditorialMotion = {
      revealObserver: null,
      ticking: false,
      media: [],

      init: function () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        document.documentElement.classList.add('manila-motion-ready');

        if (!this.revealObserver) {
          this.revealObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-manila-visible');
              observer.unobserve(entry.target);
            });
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        }

        document.querySelectorAll('#MainContent > .shopify-section:not([data-manila-reveal])').forEach(function (section) {
          section.setAttribute('data-manila-reveal', '');
          window.ManilaEditorialMotion.revealObserver.observe(section);
        });

        document.querySelectorAll('.manila-hero__picture img, .manila-campaign img, .manila-department img, .manila-horizontal-image img, .manila-store__background').forEach(function (image) {
          if (image.hasAttribute('data-manila-parallax')) return;
          image.setAttribute('data-manila-parallax', '');
          window.ManilaEditorialMotion.media.push(image);
        });

        this.updateParallax();
      },

      requestParallax: function () {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          window.ManilaEditorialMotion.updateParallax();
          window.ManilaEditorialMotion.ticking = false;
        });
      },

      updateParallax: function () {
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        var intensity = window.innerWidth < 750 ? 8 : 18;

        this.media = this.media.filter(function (image) {
          return document.documentElement.contains(image);
        });

        this.media.forEach(function (image) {
          var rect = image.parentElement.getBoundingClientRect();
          if (rect.bottom < -100 || rect.top > viewport + 100) return;
          var distance = rect.top + rect.height / 2 - viewport / 2;
          var range = viewport + rect.height;
          var offset = Math.max(-intensity, Math.min(intensity, distance / range * intensity * -2));
          image.style.setProperty('--manila-parallax-y', offset.toFixed(2) + 'px');
        });
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
      window.ManilaEditorialMotion.init();
    });

    document.addEventListener('shopify:section:load', function () {
      window.ManilaEditorialMotion.init();
    });

    window.addEventListener('scroll', function () {
      window.ManilaEditorialMotion.requestParallax();
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.ManilaEditorialMotion.requestParallax();
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
